export default {
    excess: 'Självrisk',
    security: 'Säkerhetsdeposition',
    fuel_policy: 'Bränslepolicy',
    like_for_like: 'Likvärdig bil',
    full_to_full: 'Full till full',
    mileage: 'Körsträcka: {mileage} miles per uthyrning',
    unlimited_mileage: 'Obegränsad körsträcka',
    non_refundable: 'Ej återbetalningsbar',
    free_cancellation_until: 'Gratis avbokning fram till {date}',
    cancellation_with_terms: 'Avbokning {0} enligt ',
    t_c_text: 'Villkor',
    two_free_extras: 'Två gratis tillval vid upphämtning',
    glass_tyres_covered: 'Glas och däck täcks',
    spec_fuel_petrol: 'bensin',
    spec_fuel_petrol_diesel: 'bensin/diesel',
};
